/**
 * Thin wrapper around `leokit-shielded-sdk`'s ShieldedClient that injects
 * our configured base URL and surfaces the HPKE-sealed call helpers as
 * a single ZcashWallet-shaped client.
 *
 * The SDK itself is off-limits (we don't modify upstream) — this module
 * exists so the rest of the app talks to one stable internal surface,
 * and any future shape changes happen here, not in 30 call sites.
 */

import { ShieldedClient } from "leokit-shielded-sdk";
import { SHIELDED_BASE_URL } from "./config";

let _client: ShieldedClient | null = null;

/** Lazy singleton — only constructed on first use. */
export function getShieldedClient(): ShieldedClient {
  if (!_client) {
    _client = new ShieldedClient({ baseUrl: SHIELDED_BASE_URL });
  }
  return _client;
}
